import * as React from "react";
import { useTranslation } from "react-i18next";
import { FunctionComponent } from "react";

//MUI Icons
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

//Custom Components
import CardActionButton from "@/ui/Card/CardActionButton";

//Types
import { ICardActionButtonDetail } from "@/@types/ui/Card";

const CardActionButtonDelete: FunctionComponent<ICardActionButtonDetail> = (props) => {
  const { t } = useTranslation();

  return (
    <CardActionButton startIcon={<DeleteForeverIcon />} {...props} ariaLabel="Save" ariaControls="Save">
      {t("buttons.delete")}
    </CardActionButton>
  );
};

export default CardActionButtonDelete;
